import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  FormGroup,
  Label,
  Col
} from "reactstrap";
import { GetProvince, GetTitleName } from "./share/api/MasterDataApi";

export const AddEditAuthorized = ({
  isOpen,
  toggle,
  onSubmit,
  initialData,
  mode,
  copyAddressData
}) => {
  const [formData, setFormData] = useState(initialData || {});
  console.log("formData",formData);
  const [locationProvince, setLocationProvince] = useState([]);
  const [listAuthAmphur, setListAuthAmphur] = useState([]);
  const [listAuthTumbon, setListAuthTumbon] = useState([]);
  const [locationCurrentProvince, setLocationCurrentProvince] = useState([]);
  const [listCurrentAmphur, setListCurrentAmphur] = useState([]);
  const [listCurrentTumbon, setListCurrentTumbon] = useState([]);
  const [titleName, setTitleName] = useState([]);
  const [loading, setLoading] = useState(false);

  // sync เมื่อ initialData เปลี่ยน (เปิด modal แก้ไขรายการอื่น)
  useEffect(() => {
    setFormData(initialData || {});
  }, [initialData]);

  // โหลด master จังหวัด + คำนำหน้า
  useEffect(() => {
    GetProvince({ setLocationProvince, setLoading });
    GetTitleName({ setTitleName, setLoading });
  }, []);

  // ใช้ชุดจังหวัดเดียวกันกับ current
  useEffect(() => {
    setLocationCurrentProvince(locationProvince);
  }, [locationProvince]);

  // ------- util: อัปเดตฟิลด์แบบย่อย -------
  const handleChange = (field) => (e) => {
    setFormData((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleSave = () => {
    const { authTitleId, authFullName, authPersonalId } = formData || {};
    if (authTitleId && authFullName && `${authPersonalId || ""}`.length === 13) {
      onSubmit(formData);
      toggle();
    } else {
      alert("กรุณากรอกข้อมูลให้ครบถ้วน และเลขบัตรประชาชนต้อง 13 หลัก");
    }
  };

  // ================== Fetch helpers (พารามิเตอร์ ไม่อ่านจาก state) ==================
  async function fetchAmphurByProvince(provinceCode) {
    if (!provinceCode) return [];
    const postData = new FormData();
    postData.append("provinceCode", provinceCode);
    const res = await fetch("/api/MasterData/getAmphur", { method: "POST", body: postData });
    const data = await res.json();
    return data?.dataenum ?? [];
  }

  async function fetchTumbonByProvAmphur(provinceCode, amphurCode) {
    if (!provinceCode || !amphurCode) return [];
    const postData = new FormData();
    postData.append("provinceCode", provinceCode);
    postData.append("amphurCode", amphurCode);
    const res = await fetch("/api/MasterData/getTumbon", { method: "POST", body: postData });
    const data = await res.json();
    return data?.dataenum ?? [];
  }

  async function fetchLocationId(provinceCode, amphurCode, tumbonCode) {
    if (!provinceCode || !amphurCode || !tumbonCode) return "";
    const postData = new FormData();
    postData.append("provinceCode", provinceCode);
    postData.append("amphurCode", amphurCode);
    postData.append("tumbonCode", tumbonCode);
    const res = await fetch("/api/MasterData/getLocationId", { method: "POST", body: postData });
    const data = await res.json();
    return data?.dataenum?.[0]?.locationId ?? "";
  }

  // ================== Main address (ทะเบียนบ้าน) ==================
  async function GetAmphur(e) {
    if (!e) return;
    const { value } = e.target;
    const amphurData = await fetchAmphurByProvince(value);
    setListAuthAmphur(amphurData);
  }

  async function GetTumbon(e) {
    if (!e) return;
    const province = formData.authAddressProvince;
    const amphur = e.target.value;
    const tumbonData = await fetchTumbonByProvAmphur(province, amphur);
    setListAuthTumbon(tumbonData);
  }

  async function GetLocationsId(e) {
    if (!e) return;
    const tumbonId = e.target.value;
    const provinceId = formData.authAddressProvince;
    const amphurId = formData.authAddressDistrict;
    const locationId = await fetchLocationId(provinceId, amphurId, tumbonId);
    setFormData((prev) => ({ ...prev, authAddressLocationId: locationId || "" }));
  }

  // ================== Current address (ปัจจุบัน) ==================
  async function GetAmphurCurrent(e) {
    const province = e?.target?.value;
    const amphurList = await fetchAmphurByProvince(province);
    setListCurrentAmphur(amphurList);
  }

  async function GetTumbonCurrent(e) {
    const amphur = e?.target?.value;
    const province = formData.currentAddressProvince; // ถูกเซ็ตแล้วจาก onChange province current
    const tumbonList = await fetchTumbonByProvAmphur(province, amphur);
    setListCurrentTumbon(tumbonList);
  }

  async function GetLocationsIdCurrent(e) {
    const tumbon = e?.target?.value;
    const province = formData.currentAddressProvince;
    const amphur = formData.currentAddressDistrict;
    const locationId = await fetchLocationId(province, amphur, tumbon);
    setFormData((prev) => ({ ...prev, currentAddressLocationId: locationId }));
  }

  // ====== ใช้ตอนเปิด modal โหมดแก้ไข: เติมลิสต์จากค่าเดิม ======
  async function GetAmphurIsOpen() {
    if (mode !== "add" && formData?.authAddressProvince) {
      const amphurData = await fetchAmphurByProvince(formData.authAddressProvince);
      setListAuthAmphur(amphurData);
    }
  }

  async function GetTumbonIsOpen() {
    if (mode !== "add" && formData?.authAddressProvince && formData?.authAddressDistrict) {
      const tumbonData = await fetchTumbonByProvAmphur(
        formData.authAddressProvince,
        formData.authAddressDistrict
      );
      setListAuthTumbon(tumbonData);
    }
  }

  async function GetAmphurCurrentIsOpen() {
    if (mode !== "add" && formData?.currentAddressProvince) {
      const amphurData = await fetchAmphurByProvince(formData.currentAddressProvince);
      setListCurrentAmphur(amphurData);
    }
  }

  async function GetTumbonCurrentIsOpen() {
    if (
      mode !== "add" &&
      formData?.currentAddressProvince &&
      formData?.currentAddressDistrict
    ) {
      const tumbonData = await fetchTumbonByProvAmphur(
        formData.currentAddressProvince,
        formData.currentAddressDistrict
      );
      setListCurrentTumbon(tumbonData);
    }
  }

  // เติมลิสต์เมื่อเปิด modal / โหมดแก้ไข (หลีกเลี่ยงใส่ formData ใน dependency เพื่อไม่ให้ยิงซ้ำ)
  useEffect(() => {
    if (isOpen) {
      GetAmphurIsOpen();
      GetTumbonIsOpen();
      GetAmphurCurrentIsOpen();
      GetTumbonCurrentIsOpen();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode, isOpen]);

  // ====== Checkbox: คัดลอกจากทะเบียนบ้าน ไปปัจจุบัน ======
  const handleCopyCurrentFromMain = async (e) => {
    if (e.target.checked) {
      const p = formData.authAddressProvince || "";
      const a = formData.authAddressDistrict || "";
      const t = formData.authAddressTumbon || "";

      // 1) โหลดลิสต์ตาม province/district ต้นทาง เพื่อให้ dropdown current พร้อม
      if (p) {
        const amphurs = await fetchAmphurByProvince(p);
        setListCurrentAmphur(amphurs);
      }
      if (p && a) {
        const tumbons = await fetchTumbonByProvAmphur(p, a);
        setListCurrentTumbon(tumbons);
      }

      // 2) หา locationId ถ้ามีครบ p/a/t
      const locId = p && a && t ? await fetchLocationId(p, a, t) : "";

      // 3) เซ็ตค่าฝั่ง current ทีเดียว
      setFormData((prev) => ({
        ...prev,
        currentAddressNo: prev.authAddressNo || "",
        currentAddressMoo: prev.authAddressMoo || "",
        currentAddressSoi: prev.authAddressSoi || "",
        currentAddressStreet: prev.authAddressStreet || "",
        currentAddressProvince: p,
        currentAddressDistrict: a,
        currentAddressTumbon: t,
        currentAddressPostCode: prev.authAddressPostCode || "",
        currentAddressLocationId: locId
      }));
    } else {
      // uncheck → เคลียร์ค่า current
      setFormData((prev) => ({
        ...prev,
        currentAddressNo: "",
        currentAddressMoo: "",
        currentAddressSoi: "",
        currentAddressStreet: "",
        currentAddressProvince: "",
        currentAddressDistrict: "",
        currentAddressTumbon: "",
        currentAddressPostCode: "",
        currentAddressLocationId: ""
      }));
      setListCurrentAmphur([]);
      setListCurrentTumbon([]);
    }
  };

  // ================== (ตัวเลือก) ใช้ใน flow copy อื่นๆ ถ้ามีการส่ง copyAddressData เข้ามา ==================
  async function GetAmphurForCopy(values) {
    if (!values) return;
    const amphurs = await fetchAmphurByProvince(values);
    setListAuthAmphur(amphurs);
  }

  async function GetCurTumbonForCopy(values) {
    if (!values) return;
    const provinceCode =
      copyAddressData?.addProvince || copyAddressData?.address?.provinceCode;
    const tumbons = await fetchTumbonByProvAmphur(provinceCode, values);
    setListAuthTumbon(tumbons);
  }

  // ================== Render ==================
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      style={{ maxWidth: "870px", width: "100%" }}
      scrollable
      backdrop={"static"}
      keyboard={false}
    >
      <ModalHeader toggle={toggle}>
        {mode === "edit" ? "แก้ไขผู้มีอำนาจ" : "เพิ่มผู้มีอำนาจ"}
      </ModalHeader>
      <ModalBody>
        <div className="px-4 pt-3">
          <FormGroup row>
            <Label for="authFullName">
              ชื่อ - สกุล<span className="require-input">*</span>
            </Label>
            <div className="d-flex justify-content-start px-6">
              <div className="flex-grow-1">
                <Input
                  type="select"
                  value={formData.authTitleId || ""}
                  onChange={handleChange("authTitleId")}
                  className="rounded-pill rounded-end text-center input-color"
                >
                  <option value="">คำนำหน้า</option>
                  {titleName?.map((title) => (
                    <option key={title.titleCode} value={title.titleCode}>
                      {title.titleThai}
                    </option>
                  ))}
                </Input>
              </div>
              <div className="w-75">
                <Input
                  type="text"
                  value={formData.authFullName || ""}
                  onChange={handleChange("authFullName")}
                  placeholder="ชื่อ-สกุล"
                  className="rounded-pill rounded-start text-center input-color"
                />
              </div>
            </div>
          </FormGroup>

          <FormGroup row>
            <Label for="authPersonalId">
              เลขบัตรประจำตัวประชาชน<span className="require-input">*</span>
            </Label>
            <Input
              type="text"
              maxLength={13}
              value={formData.authPersonalId || ""}
              onChange={(e) => {
                const onlyNums = e.target.value.replace(/\D/g, "");
                handleChange("authPersonalId")({ target: { value: onlyNums } });
              }}
              className="rounded-pill text-center input-color px-6"
            />
          </FormGroup>
        </div>

        <Label className="px-4">ที่อยู่ตามทะเบียนบ้าน<span className="require-input">*</span></Label>

        <div className="px-5 mt-2">
          <FormGroup row>
            <Label sm={2}>เลขที่<span className="require-input">*</span></Label>
            <Col sm={4}>
              <Input
                value={formData.authAddressNo || ""}
                onChange={handleChange("authAddressNo")}
                className="rounded-pill text-center input-color"
              />
            </Col>
            <Label sm={2}>หมู่ที่</Label>
            <Col sm={4}>
              <Input
                value={formData.authAddressMoo || ""}
                onChange={handleChange("authAddressMoo")}
                className="rounded-pill text-center input-color"
              />
            </Col>
          </FormGroup>

          <FormGroup row>
            <Label sm={2}>ซอย</Label>
            <Col sm={4}>
              <Input
                value={formData.authAddressSoi || ""}
                onChange={handleChange("authAddressSoi")}
                className="rounded-pill text-center input-color"
              />
            </Col>
            <Label sm={2}>ถนน</Label>
            <Col sm={4}>
              <Input
                value={formData.authAddressStreet || ""}
                onChange={handleChange("authAddressStreet")}
                className="rounded-pill text-center input-color"
              />
            </Col>
          </FormGroup>

          <FormGroup row>
            <Label sm={2}>จังหวัด<span className="require-input">*</span></Label>
            <Col sm={4}>
              <Input
                type="select"
                value={formData.authAddressProvince || ""}
                className="rounded-pill text-center input-color"
                onChange={async (e) => {
                  handleChange("authAddressProvince")(e);
                  // เคลียร์ที่พึ่งพา
                  setFormData((prev) => ({
                    ...prev,
                    authAddressDistrict: "",
                    authAddressTumbon: "",
                    authAddressLocationId: ""
                  }));
                  setListAuthAmphur([]);
                  setListAuthTumbon([]);
                  await GetAmphur(e);
                }}
              >
                <option value="">กรุณาเลือกจังหวัด</option>
                {locationProvince?.map((province) => (
                  <option key={province.provinceCode} value={province.provinceCode}>
                    {province.provinceName}
                  </option>
                ))}
              </Input>
            </Col>

            <Label sm={2}>อำเภอ/เขต<span className="require-input">*</span></Label>
            <Col sm={4}>
              <Input
                type="select"
                value={formData.authAddressDistrict || ""}
                className="rounded-pill text-center input-color"
                onChange={async (e) => {
                  handleChange("authAddressDistrict")(e);
                  setFormData((prev) => ({
                    ...prev,
                    authAddressTumbon: "",
                    authAddressLocationId: ""
                  }));
                  setListAuthTumbon([]);
                  await GetTumbon(e);
                }}
              >
                <option value="">กรุณาเลือกอำเภอ/เขต</option>
                {listAuthAmphur?.map((amphur) => (
                  <option key={amphur.amphurCode} value={amphur.amphurCode}>
                    {amphur.amphurName}
                  </option>
                ))}
              </Input>
            </Col>
          </FormGroup>

          <FormGroup row>
            <Label sm={2}>ตำบล/แขวง<span className="require-input">*</span></Label>
            <Col sm={4}>
              <Input
                type="select"
                value={formData.authAddressTumbon || ""}
                className="rounded-pill text-center input-color"
                onChange={(e) => {
                  GetLocationsId(e);
                  handleChange("authAddressTumbon")(e);
                }}
              >
                <option value="">กรุณาเลือกตำบล/แขวง</option>
                {listAuthTumbon?.map((tumbon) => (
                  <option key={tumbon.tumbonCode} value={tumbon.tumbonCode}>
                    {tumbon.tumbonName}
                  </option>
                ))}
              </Input>
            </Col>
            <Label sm={2}>รหัสไปรษณีย์<span className="require-input">*</span></Label>
            <Col sm={4}>
              <Input
                type="text"
                maxLength={5}
                value={formData.authAddressPostCode || ""}
                onChange={handleChange("authAddressPostCode")}
                className="rounded-pill text-center input-color"
              />
            </Col>
          </FormGroup>
        </div>

        <Label className="px-4 mt-4">ที่อยู่ปัจจุบัน<span className="require-input">*</span></Label>
        <FormGroup className="px-5 mt-2">
          <Input
            type="checkbox"
            className="cus-type me-2"
            onClick={handleCopyCurrentFromMain}
          />
          <Label>ใช้ที่อยู่ตามที่อยู่ตามทะเบียนบ้าน</Label>
        </FormGroup>

        <div className="px-5 mt-2">
          <FormGroup row>
            <Label sm={2}>เลขที่<span className="require-input">*</span></Label>
            <Col sm={4}>
              <Input
                value={formData.currentAddressNo || ""}
                onChange={handleChange("currentAddressNo")}
                className="rounded-pill text-center input-color"
              />
            </Col>
            <Label sm={2}>หมู่ที่</Label>
            <Col sm={4}>
              <Input
                value={formData.currentAddressMoo || ""}
                onChange={handleChange("currentAddressMoo")}
                className="rounded-pill text-center input-color"
              />
            </Col>
          </FormGroup>

          <FormGroup row>
            <Label sm={2}>ซอย</Label>
            <Col sm={4}>
              <Input
                value={formData.currentAddressSoi || ""}
                onChange={handleChange("currentAddressSoi")}
                className="rounded-pill text-center input-color"
              />
            </Col>
            <Label sm={2}>ถนน</Label>
            <Col sm={4}>
              <Input
                value={formData.currentAddressStreet || ""}
                onChange={handleChange("currentAddressStreet")}
                className="rounded-pill text-center input-color"
              />
            </Col>
          </FormGroup>

          <FormGroup row>
            <Label sm={2}>จังหวัด<span className="require-input">*</span></Label>
            <Col sm={4}>
              <Input
                type="select"
                value={formData.currentAddressProvince || ""}
                className="rounded-pill text-center input-color"
                onChange={async (e) => {
                  handleChange("currentAddressProvince")(e);
                  setFormData((prev) => ({
                    ...prev,
                    currentAddressDistrict: "",
                    currentAddressTumbon: "",
                    currentAddressLocationId: ""
                  }));
                  setListCurrentAmphur([]);
                  setListCurrentTumbon([]);
                  await GetAmphurCurrent(e);
                }}
              >
                <option value="">กรุณาเลือกจังหวัด</option>
                {locationCurrentProvince?.map((province) => (
                  <option key={province.provinceCode} value={province.provinceCode}>
                    {province.provinceName}
                  </option>
                ))}
              </Input>
            </Col>

            <Label sm={2}>อำเภอ/เขต<span className="require-input">*</span></Label>
            <Col sm={4}>
              <Input
                type="select"
                value={formData.currentAddressDistrict || ""}
                className="rounded-pill text-center input-color"
                onChange={async (e) => {
                  handleChange("currentAddressDistrict")(e);
                  setFormData((prev) => ({
                    ...prev,
                    currentAddressTumbon: "",
                    currentAddressLocationId: ""
                  }));
                  setListCurrentTumbon([]);
                  await GetTumbonCurrent(e);
                }}
              >
                <option value="">กรุณาเลือกอำเภอ/เขต</option>
                {listCurrentAmphur?.map((amphur) => (
                  <option key={amphur.amphurCode} value={amphur.amphurCode}>
                    {amphur.amphurName}
                  </option>
                ))}
              </Input>
            </Col>
          </FormGroup>

          <FormGroup row>
            <Label sm={2}>ตำบล/แขวง<span className="require-input">*</span></Label>
            <Col sm={4}>
              <Input
                type="select"
                value={formData.currentAddressTumbon || ""}
                className="rounded-pill text-center input-color"
                onChange={(e) => {
                  GetLocationsIdCurrent(e);
                  handleChange("currentAddressTumbon")(e);
                }}
              >
                <option value="">กรุณาเลือกตำบล/แขวง</option>
                {listCurrentTumbon?.map((tumbon) => (
                  <option key={tumbon.tumbonCode} value={tumbon.tumbonCode}>
                    {tumbon.tumbonName}
                  </option>
                ))}
              </Input>
            </Col>
            <Label sm={2}>รหัสไปรษณีย์<span className="require-input">*</span></Label>
            <Col sm={4}>
              <Input
                type="text"
                maxLength={5}
                value={formData.currentAddressPostCode || ""}
                onChange={handleChange("currentAddressPostCode")}
                className="rounded-pill text-center input-color"
              />
            </Col>
          </FormGroup>
        </div>
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          ยกเลิก
        </Button>
        <Button color="primary" onClick={handleSave}>
          บันทึก
        </Button>
      </ModalFooter>
    </Modal>
  );
};
